import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DropdownModule } from '../common/dropdown/dropdown.module';
import { IconModule } from '../common/icon/icon.module';
import { RtUICoreOverlayModule } from '../core/overlay/overlay.module';
import { DropdownItem, DropdownScrollableComponent } from './dropdown-scrollable.component';

@NgModule({
  imports: [CommonModule, DropdownModule, IconModule, RtUICoreOverlayModule],
  declarations: [DropdownScrollableComponent],
  exports: [DropdownScrollableComponent],
})
export class RtDropdownScrollableModule {}
export { DropdownItem, DropdownScrollableComponent };
